/**
 * Rich Text Editor classes defined here.
 */
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE = 'e-richtexteditor';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTL = 'e-rtl';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CONTENT = 'e-content';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DISABLED = 'e-disabled';
/**
 * @hidden
 * @deprecated
 */
export var CLS_SCRIPT_SHEET = 'rte-iframe-script-sheet';
/**
 * @hidden
 * @deprecated
 */
export var CLS_STYLE_SHEET = 'rte-iframe-style-sheet';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TOOLBAR = 'e-rte-toolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_FIXED = 'e-rte-tb-fixed';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_FLOAT = 'e-rte-tb-float';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_ABS_FLOAT = 'e-rte-tb-abs-float';
/**
 * @hidden
 * @deprecated
 */
export var CLS_INLINE = 'e-rte-inline';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_INLINE = 'e-rte-tb-inline';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_EXPAND_TB = 'e-rte-tb-expand';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FULL_SCREEN = 'e-rte-full-screen';
/**
 * @hidden
 * @deprecated
 */
export var CLS_QUICK_TB = 'e-rte-quick-toolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_POP = 'e-rte-pop';
/**
 * @hidden
 * @deprecated
 */
export var CLS_QUICK_POP = 'e-rte-quick-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_QUICK_DROPDOWN = 'e-quick-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMAGE_POP = 'e-rte-image-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_INLINE_POP = 'e-rte-inline-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_INLINE_DROPDOWN = 'e-rte-inline-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPDOWN_POPUP = 'e-rte-dropdown-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPDOWN_ICONS = 'e-rte-dropdown-icons';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPDOWN_ITEMS = 'e-rte-dropdown-items';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPDOWN_BTN = 'e-rte-dropdown-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_CONTENT = 'e-rte-content';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_ITEM = 'e-toolbar-item';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_EXTENDED = 'e-toolbar-extended';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_WRAP = 'e-toolbar-wrapper';
/**
 * @hidden
 * @deprecated
 */
export var CLS_POPUP = 'e-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_SEPARATOR = 'e-separator';
/**
 * @hidden
 * @deprecated
 */
export var CLS_MINIMIZE = 'e-minimize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_MAXIMIZE = 'e-maximize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_BACK = 'e-back';
/**
 * @hidden
 * @deprecated
 */
export var CLS_SHOW = 'e-show';
/**
 * @hidden
 * @deprecated
 */
export var CLS_HIDE = 'e-hide';
/**
 * @hidden
 * @deprecated
 */
export var CLS_VISIBLE = 'e-visible';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FOCUS = 'e-focused';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RM_WHITE_SPACE = 'e-remove-white-space';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMGRIGHT = 'e-imgright';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMGLEFT = 'e-imgleft';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMGCENTER = 'e-imgcenter';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMGBREAK = 'e-imgbreak';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CAPTION = 'e-img-caption';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_CAPTION = 'e-rte-img-caption';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CAPINLINE = 'e-caption-inline';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMGINLINE = 'e-imginline';
/**
 * @hidden
 * @deprecated
 */
export var CLS_COUNT = 'e-rte-character-count';
/**
 * @hidden
 * @deprecated
 */
export var CLS_WARNING = 'e-warning';
/**
 * @hidden
 * @deprecated
 */
export var CLS_ERROR = 'e-error';
/**
 * @hidden
 * @deprecated
 */
export var CLS_ICONS = 'e-icons';
/**
 * @hidden
 * @deprecated
 */
export var CLS_ACTIVE = 'e-active';
/**
 * @hidden
 * @deprecated
 */
export var CLS_EXPAND_OPEN = 'e-expand-open';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_ELEMENTS = 'e-rte-elements';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_BTN = 'e-tbar-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_HR_SEPARATOR = 'e-rte-horizontal-separator';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_IOS_FIX = 'e-tbar-ios-fixed';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_STATIC = 'e-tb-static';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FORMATS_TB_BTN = 'e-formats-tbar-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FONT_NAME_TB_BTN = 'e-font-name-tbar-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FONT_SIZE_TB_BTN = 'e-font-size-tbar-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FONT_COLOR_TARGET = 'e-rte-fontcolor-element';
/**
 * @hidden
 * @deprecated
 */
export var CLS_BACKGROUND_COLOR_TARGET = 'e-rte-backgroundcolor-element';
/**
 * @hidden
 * @deprecated
 */
export var CLS_COLOR_CONTENT = 'e-rte-color-content';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FONT_COLOR_DROPDOWN = 'e-rte-fontcolor-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_BACKGROUND_COLOR_DROPDOWN = 'e-rte-backgroundcolor-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_COLOR_PALETTE = 'e-rte-square-palette';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FONT_COLOR_PICKER = 'e-rte-fontcolor-colorpicker';
/**
 * @hidden
 * @deprecated
 */
export var CLS_BACKGROUND_COLOR_PICKER = 'e-rte-backgroundcolor-colorpicker';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_READONLY = 'e-rte-readonly';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TABLE_SEL = 'e-cell-select';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_DASH_BOR = 'e-dashed-border';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_ALT_BOR = 'e-alternate-border';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_COL_RES = 'e-column-resize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_ROW_RES = 'e-row-resize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_BOX_RES = 'e-table-box';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_HIDDEN = 'e-rte-hidden';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_PASTE_KEEP_FORMAT = 'e-rte-keepformat';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_PASTE_REMOVE_FORMAT = 'e-rte-removeformat';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_PASTE_PLAIN_FORMAT = 'e-rte-plainformat';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_PASTE_OK = 'e-rte-pasteok';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_PASTE_CANCEL = 'e-rte-pastecancel';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_DIALOG_MIN_HEIGHT = 'e-rte-dialog-minheight';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_RES_HANDLE = 'e-resize-handle';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_RES_EAST = 'e-south-east';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_IMAGE = 'e-rte-image';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RESIZE = 'e-resize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMG_FOCUS = 'e-img-focus';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_DRAG_IMAGE = 'e-rte-drag-image';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_UPLOAD_POPUP = 'e-rte-upload-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_POPUP_OPEN = 'e-popup-open';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMG_RESIZE = 'e-img-resize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPAREA = 'e-droparea';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMG_INNER = 'e-img-inner';
/**
 * @hidden
 * @deprecated
 */
export var CLS_UPLOAD_FILES = 'e-upload-files';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_DIALOG_UPLOAD = 'e-rte-dialog-upload';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_RES_CNT = 'e-rte-resize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CUSTOM_TILE = 'e-custom-tile';
/**
 * @hidden
 * @deprecated
 */
export var CLS_NOCOLOR_ITEM = 'e-nocolor-item';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TABLE = 'e-rte-table';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TABLE_BORDER = 'e-rte-table-border';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_TABLE_RESIZE = 'e-rte-table-resize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_FIXED_TB_EXPAND = 'e-rte-fixed-tb-expand';
